import { JsonObject } from 'json2typescript';
import { ChatReferenceDataResponseInterface } from '../interfaces/chat-referencedata-response.interface';
import { CategoriesResponseModel } from './categories-response.model';
import { UserDataResponseModel } from './userdata-response.model';

@JsonObject('ChatReferenceDataResponseModel')
export class ChatReferenceDataResponseModel
  implements ChatReferenceDataResponseInterface
{
  Categories: CategoriesResponseModel[];
  UserData: UserDataResponseModel;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
